'use client';

// Package Imports
import React, { useState } from 'react';

// Style Imports
import styles from './modalRegistration.module.scss';

// Component Imports
import Modal from "@/components/modal";
import AccountRegistration from "@/components/accountRegistration";

interface ModalRegistrationProps {
  isOpen?: boolean;
  setIsOpen?: (state: boolean) => void;
}

const ModalRegistration: React.FC<ModalRegistrationProps> = ({ isOpen: externalIsOpen, setIsOpen: externalSetIsOpen }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  // Determine which state to use
  const isModalOpen = externalIsOpen ?? internalIsOpen;
  const setModalOpen = externalSetIsOpen ?? setInternalIsOpen;

  const onRegistrationSuccess = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setModalOpen(false)}
      enableCloseButton={true}
      enableDismiss={true}
      modalClass={styles.modalRegistrationContainer}
      content={
        <div className={styles.modalRegistration}>
          <h1>Registration</h1>
          <AccountRegistration onRegisterSuccess={onRegistrationSuccess} />
        </div>
      }
    />
  );
};

export default ModalRegistration;
